module.exports = __webpack_public_path__ + "static/media/liquid_22_detail_12.3362edf6.jpg";